import React from 'react';

import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

import { getTitleId } from 'components/Pages/Admin/Page/Landing/utils';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import { useScrollOffset } from 'hooks/useScrollOffset';
import { IPage } from 'utils/itineraryDetails/types';

import { useScrollToCurrentDatePage } from './useScrollToCurrentDatePage';

type Props = {
  pages?: IPage[];
  landingTheme?: string;
  isCurrentTrip?: boolean;
};

export const useWebViewScroll = ({ pages = [], landingTheme, isCurrentTrip }: Props) => {
  const { search } = useLocation();
  const { clickOffset } = useScrollOffset({ landingTheme, isItinerariesItem: true });
  const { handleScrollToCurrentDatePage } = useScrollToCurrentDatePage({ pages, landingTheme });

  React.useEffect(() => {
    if (new URLSearchParams(search).get('webview') !== 'true') return;

    const handleScrollToAnchor = () => {
      const anchor = new URLSearchParams(search).get('block_id') ?? window.location.hash.substring(1);

      if (!anchor) {
        if (isCurrentTrip) handleScrollToCurrentDatePage();
        return;
      }

      const targetPageIndex = pages.findIndex((page) => page.id === Number(anchor));

      if (targetPageIndex === -1) return;
      const targetPage = pages[targetPageIndex];

      const targetLink = getTitleId(targetPage.headline, targetPageIndex);
      if (!targetLink) return;

      setTimeout(() => {
        scroller.scrollTo(targetLink, {
          containerId: LANDING_PAGES_CONTAINER_ID,
          smooth: true,
          duration: 200,
          offset: clickOffset(targetPageIndex === 0),
        });
      });
    };

    handleScrollToAnchor();
    window.history.replaceState({}, '', window.location.pathname + window.location.search);
  }, []);
};
